import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { MqttClientContext } from 'components/system/app'
import { mqttSubscribe } from 'services/mqtt-service'
import { useBrand } from 'hooks/useBrand'
import { useActiveScreens } from 'hooks/useScreens'
import { MQTT_TOPIC, DASHBOARD } from 'constants/appConstants'
import View from './view'

const Home = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const screens = useActiveScreens()
  const [isDebug, setIsDebug] = useState(false)
  const [isScreenSelectorOpened, setIsScreenSelectorOpened] = useState(false)
  const [screenSelected, setScreenSelected] = useState({})
  const [isModalDisabled, setIsModalDisabled] = useState(false)

  const mqttClient = useContext(MqttClientContext)
  const { setBrand } = useBrand()

  const [payload, setPayload] = useState({})

  useEffect(() => {
    if (searchParams.get('debug')) {
      const debugBool = searchParams.get('debug') === 'true'
      setIsDebug(debugBool)
    }
  }, [])

  mqttClient.on('message', (topic, message) => {
    setPayload({ topic, message: message.toString() })
  })

  const topic = `${MQTT_TOPIC}${
    screenSelected.value ? screenSelected?.value : JSON.parse(localStorage.getItem('screenApp'))?.value
  }`

  const subscribe = () => {
    if (mqttClient) {
      mqttSubscribe(mqttClient, topic)
    }
  }

  const handleScreenChange = value => {
    setScreenSelected(value)
    setBrand(value.brand)
    localStorage.setItem('screenApp', JSON.stringify(value))
  }

  const onClose = () => {
    subscribe()
    setIsScreenSelectorOpened(false)
    navigate(DASHBOARD, { state: { screenSelected: screenSelected.value } })
  }

  const tapToControl = () => {
    const screenAppStorage = localStorage.getItem('screenApp')
    if (isDebug || !screenAppStorage) {
      setIsScreenSelectorOpened(true)
    } else {
      subscribe()
      navigate(DASHBOARD)
    }
  }

  useEffect(() => {
    if (Object.keys(screenSelected).length === 0 || !localStorage.getItem('screenApp')) {
      setIsModalDisabled(true)
    } else {
      setIsModalDisabled(false)
    }
  }, [screenSelected])

  return (
    <View
      tapToControl={tapToControl}
      isScreenSelectorOpened={isScreenSelectorOpened}
      onClose={onClose}
      isModalDisabled={isModalDisabled}
      screens={screens}
      handleScreenChange={handleScreenChange}
      screenSelected={screenSelected}
    />
  )
}

export default Home
